interface DateDisplayCardProps {
  dateLabel: string;
  dateDisplay: string;
}

// The badge must hold localized labels ("Yesterday", "Gestern", "Morgen") and
// dates ("11. Sept.", "Sep 11") on one line each — no artificial hyphenation.
const DateDisplayCard = ({ dateLabel, dateDisplay }: DateDisplayCardProps) => {
  const labelSizeClass = dateLabel.length > 6 ? "text-sm" : "";

  return (
    <div className="flex w-[88px] shrink-0">
      <div className="w-[84px] bg-grey-95 dark:bg-primary-90 flex h-full flex-col items-center justify-center rounded-lg px-2 py-2.5 text-center">
        <p className={`dark:text-primary-40 font-semibold leading-tight whitespace-nowrap ${labelSizeClass}`}>
          {dateLabel}
        </p>
        <p className="dark:text-primary-40 text-sm font-semibold whitespace-nowrap">
          {dateDisplay}
        </p>
      </div>
    </div>
  );
};

export default DateDisplayCard;
